import React, { useState } from 'react';
import { Box, Typography, Button, Alert, Snackbar, CircularProgress, Tooltip } from '@mui/material';
import { evoWebhookConfigService } from '../services/firebaseFunctions';
import { useAuth } from '../contexts/AuthContext';

const EvoWebhooksBackfillPage: React.FC = () => {
  const { hasPermission } = useAuth();
  const canManage = hasPermission('webhooks_evo', 'editar');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' as 'success' | 'error' });

  const runBackfill = async () => {
    try {
      setLoading(true);
      const result = await evoWebhookConfigService.backfillCompanyEvoWebhookConfigIds();
      if (result.success && result.data) {
        const d = result.data;
        setSnackbar({
          open: true,
          severity: 'success',
          message: `Concluído: ${d.companiesUpdated} empresas atualizadas, ${d.companiesCleared} limpas (${d.companiesScanned} analisadas).`,
        });
      } else {
        throw new Error(result.error || 'Falha no backfill');
      }
    } catch (e) {
      setSnackbar({
        open: true,
        severity: 'error',
        message: e instanceof Error ? e.message : 'Erro ao executar backfill',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, maxWidth: 560 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Sincronizar vínculo webhook nas empresas
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Atualiza o campo <code>evoWebhookConfigId</code> em cada empresa conforme o vínculo em{' '}
        <code>evo_webhook_configs</code>. Operação idempotente.
      </Alert>
      <Tooltip title={canManage ? '' : 'Você não tem permissão de edição no módulo Webhooks EVO.'}>
        <span>
          <Button variant="contained" onClick={runBackfill} disabled={!canManage || loading} startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}>
            {loading ? 'Executando…' : 'Executar backfill'}
          </Button>
        </span>
      </Tooltip>
      <Snackbar open={snackbar.open} autoHideDuration={8000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EvoWebhooksBackfillPage;
